import { Component, Mixins } from 'vue-property-decorator';
import { BvMsgBoxOptions } from 'bootstrap-vue';

declare module 'vue/types/vue' {
    interface Vue {
        $confirm(message: any, options?: BvMsgBoxOptions): Promise<boolean>
        $confirmWarning(message: any, options?: BvMsgBoxOptions): Promise<boolean>
        $ok(message: any, options?: BvMsgBoxOptions): Promise<boolean>
    }
}

@Component
export default class ConfirmationMixin extends Mixins() {
    private get dialogDefaultOptions() {
        return {
            okButton: 'OK',
            cancelButton: 'Cancel',
            buttonSize: 'sm',
            noCloseOnBackdrop: true,
            hideHeaderClose: false,
            centered: true,
        }
    }

    $confirm(message: any, options?: BvMsgBoxOptions): Promise<boolean> {
        return this.$bvModal.msgBoxConfirm(message, {
            ...this.dialogDefaultOptions,
            title: 'Please Confirm',
            headerBgVariant: 'primary',
            headerTextVariant: 'white',
            ...options,
        })
    }

    $confirmWarning(message: any, options?: BvMsgBoxOptions): Promise<boolean> {
        return this.$bvModal.msgBoxConfirm(message, {
            ...this.dialogDefaultOptions,
            title: 'Warning',
            ...options,
            headerBgVariant: 'warning',
            headerTextVariant: 'white',
            okVariant: 'danger',
        })
    }

    $ok(message: any, options?: BvMsgBoxOptions): Promise<boolean> {
        return this.$bvModal.msgBoxOk(message, {
            ...this.dialogDefaultOptions,
            title: 'Confirmation',
            headerBgVariant: 'primary',
            headerTextVariant: 'white',
            ...options,
        })
    }
}
